import 'normalize.css'
import './index.css'

import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'

import App from './app'
import * as serviceWorker from './serviceWorker'

ReactDOM.render(<App />, document.getElementById('root'))
serviceWorker.unregister()
// Fix mobile viewport
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
const vh = window.innerHeight * 0.01
document.documentElement.style.setProperty('--vh', `${vh}px`)
// GA
ReactGA.initialize('UA-2362355-30')
ReactGA.pageview(window.location.pathname + window.location.search)
